import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  itemSync01ShowSyncSetting: null,
  itemSync01ShowSyncSettingLoading: ['boolean'],
  itemSync01ShowSyncSettingSuccess: ['syncSetting'],
  itemSync01UpdateSyncSetting: ['formikBag', 'syncSetting'],
  itemSync01ShowBatchJobStatus: null,
  itemSync01ShowBatchJobStatusSuccess: ['batchJobStatus'],
  itemSync01SyncNow: ['formikBag'],
  itemSync01SyncLoading: ['boolean']
});

export const ItemSync01Types = Types;
export default Creators;
